export default {
  FITMENT_TABLE_VEHICLE_SPECIFIC: 'This Part Fits:',
};
